
// if the app should attempt to prompt users to rate the app
export const appRatingPromptEnabled: boolean = true;

// allowed app rating by device type
export const allowAppRateByTypeConfig = {
  // don't rate the iphone right now.
  iPhone: false,
  iPad: true,
  // don't rate the desktop app right now.
  desktop: false,
};

